// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2la1g"};